import Box from '@mui/material/Box';
import React, {useEffect, useMemo, useRef, useState} from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import {config} from '../common/config/config';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import {constance} from '../common/constance/constance';
import {useDispatch, useSelector} from 'react-redux';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import DehazeIcon from '@mui/icons-material/Dehaze';
import {useNavigate} from 'react-router-dom';
import axios from 'axios';
import {commonReducer} from '../reducer/common';
import {common} from '../common/common';
import {RootState} from '../reducer';
import {PostInterface} from "../interface/post.interface";
import {isMobile} from "react-device-detect";
import {styles} from "../common/style";
import SettingsIcon from '@mui/icons-material/Settings';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';
import Paper from "@mui/material/Paper";
import ChangePasswordDialog from "./dialog/ChangePasswordDialog";
import {User} from "../interface/user.interface";
import EmailIcon from '@mui/icons-material/Email';
import {Tooltip} from "@mui/material";
import {DateTime} from "luxon";
import EventConfirmDialog from "./dialog/EventConfirmDialog";

interface State {
    openMobileMenu: boolean,
    openMenu: boolean,
    selectedMenuId: string,
    selectedSubMenuId: string,
    openSettingBox: boolean,
    openNoteBox: boolean,
    openChangePassword: boolean,
}

export default function Header() {
    console.log(`[Header]`);
    const isLoginPage = window.location.pathname == "/logIn";
    const menuColumnWidth = 1 / config.menu.length / 1.05;

    const [state, setState] = useState<State>({
        openMobileMenu: false,
        openMenu: false,
        selectedMenuId: '',
        selectedSubMenuId: 'calendar',
        openSettingBox: false,
        openNoteBox: false,
        openChangePassword: false,
    });

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const commonData = useSelector((state: RootState) => state.commonData);
    const themeMode = commonData.themeMode;
    const toggleThemeMode = () => {
        dispatch(commonReducer.setThemeMode(themeMode === 'dark' ? 'light' : 'dark'));
    };
    let {id, workplace, no, page} = common.getQuery();

    const unReadCountRef: any = useRef('0');

    useEffect(() => {

        axios.get(constance.api.getUnReadCount).then(value => {
            unReadCountRef.current.innerText = value.data.unReadCount;
        })
        const unReadCountIntervalId = setInterval(() => {
            axios.get(constance.api.getUnReadCount).then(value => {
                unReadCountRef.current.innerText = value.data.unReadCount;
            })
        }, 1000 * 60)
        getUserData();
        return () => {
            clearInterval(unReadCountIntervalId);
        };
    }, []);

    const toolbarRef: any = useRef();
    const logoRef: any = useRef();
    const menuRef: any = useRef();
    const subMenuRef: any = useRef();
    const mobileToolbarRef: any = useRef();

    /* 서브메뉴 갯수 저장 => menu Height 지정을 위함 */
    const subMenuMaxHeight = useMemo(() => {
        let max = 0;
        for (let menu of config.menu) {
            let count = 0;
            if (menu.subMenu) {
                for (let subMenu of menu.subMenu) {
                    if (subMenu.usage) {
                        if (menu.id == "admin" && commonData.user.admin) {
                            count++;
                        } else if (menu.id == "admin" && !commonData.user.admin) {

                        } else {
                            count++;
                        }

                    }
                }
                if (count > max) {
                    max = count;
                }
            }
        }
        return 55 * max + 'px';
    }, [commonData.user]);


    function getUserData() {
        axios(constance.api.getUser).then(value => {
            console.log(value);
            if (value.data.data) {
                dispatch(commonReducer.setUser(value.data.data));
                if (isLoginPage) {
                    return navigate("/");
                }
            } else {
                navigate('/logIn');
            }
        }).catch(reason => {
            console.log(reason);
        });
    }

    const defaultLogoSrc = themeMode === 'dark' ? '/images/logo_black.png' : '/images/logo.png';

    function handleMouseOverMenu() {
        setState({
            ...state,
            openMenu: true,
        });
        toolbarRef.current.style.background = '#2a2a2a';
        logoRef.current.src = '/images/logo_black.png';
        subMenuRef.current.style.height = subMenuMaxHeight;
    }

    function handleMouseLeaveMenu() {
        setState({
            ...state,
            openMenu: false,
        });
        toolbarRef.current.style.background = 'var(--scc-surface)';
        logoRef.current.src = defaultLogoSrc;
        subMenuRef.current.style.height = '0px';
    }

    function openMenu() {
        console.log(state.openMobileMenu)
        if (!state.openMobileMenu) {
            mobileToolbarRef.current.style.left = '0px';
            // mobileToolbarRef.current.style.display = 'none';
            // mobileToolbarRef.current.style.width = '0px';
        } else {
            mobileToolbarRef.current.style.left = '-100vw';
            // mobileToolbarRef.current.style.display = 'flex';
            // mobileToolbarRef.current.style.width = window.innerWidth + 'px';
        }

        setState({
            ...state,
            openMobileMenu: !state.openMobileMenu,
        });
    }

    function movePage(value: any, subMenu: any) {
        const path = subMenu == null ? value.path : subMenu.path;
        subMenuRef.current.style.height = '0px';
        // mobileToolbarRef.current.style.display = 'none';
        mobileToolbarRef.current.style.left = '-100vw';
        navigate(path);
        setState({
            ...state,
            openMobileMenu: false,
            openMenu: false,
            selectedMenuId: value.id,
            selectedSubMenuId: subMenu == null ? '' : subMenu.id,
        });
        dispatch(commonReducer.setUrlPath(path));
    }

    function logOut() {
        setState({
            ...state,
            openSettingBox: false,
        })
        axios.get(constance.api.logOut).then(value => {
            console.log(value);
            dispatch(commonReducer.setUser({
                admin: false,
                departmentCode: '',
                id: '',
                name: '',
                departmentName: '',
                _id: ''
            }));
            navigate('/logIn');
        });
    }

    function moveMainPage() {
        mobileToolbarRef.current.style.left = '-100vw';
        setState({
            ...state,
            selectedMenuId: '',
        })
        navigate('/');
    }

    let userEmpty = common.isEmpty(commonData.user._id);


    function handleOpenSettingBox(key: string) {
        if (key == 'openSettingBox') {
            setState({
                ...state,
                openNoteBox: false,
                openSettingBox: !state.openSettingBox
            })
        } else if ('openNoteBox') {
            setState({
                ...state,
                openNoteBox: !state.openNoteBox,
                openSettingBox: false,
            })
        }

    }

    function handleOpenChangePassword() {
        setState({
            ...state,
            openSettingBox: false,
            openChangePassword: !state.openChangePassword
        })
    }

    /* 쪽지함 페이지 이동 */
    function handleMoveNoteBoxPage(sub: string) {
        let noteBox: any = config.noteBox;
        navigate(`${config.url.noteBox}/${sub}`);
        setState({
            ...state,
            selectedSubMenuId: sub,
            selectedMenuId: 'note-box',
            openNoteBox: false,
            openSettingBox: false,
        })
    }


    function handleMoveAttendancePage() {
        setState({
            ...state,
            openSettingBox: false,
        })
        navigate(`${config.url.attendance}/calendar`);
    }


    return (
        <>
            <AppBar component="nav"
                    sx={{display: userEmpty ? 'none' : 'inherit'}}
                    position={'fixed'}>
                {/* 모바일 */}
                <Toolbar
                    sx={{
                        display: {xs: 'flex', sm: 'flex', md: 'flex', lg: 'none'},
                        background: 'var(--scc-surface)',
                        alignItems: 'center',
                        transition: config.style.transition,
                        flexDirection: 'column',
                        width: 1,
                    }}
                    style={{padding: 0}}
                >
                    <Box sx={{display: 'flex', width: 1, position: 'relative'}}>
                        <Box sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'flex-start',
                            height: 65,
                            position: 'relative',
                        }}>
                            <Button variant={'text'}
                                    size={'small'}
                                    style={{minWidth: '30px', width: '30px'}}
                                    onClick={() => openMenu()}
                                    sx={{position: 'absolute', left: 16, color: 'text.primary'}}>
                                <DehazeIcon/>
                            </Button>
                        </Box>
                        <Box onClick={moveMainPage}
                             sx={{
                                 display: 'flex',
                                 width: 1,
                                 justifyContent: 'center',
                             }}>
                            <img ref={logoRef}
                                 src={defaultLogoSrc}
                                 style={{height: '65px', cursor: 'pointer'}}
                                 alt={'로고'}/>
                        </Box>
                        {getSettingBox(handleOpenSettingBox, state, commonData, handleOpenChangePassword, logOut, userEmpty, handleMoveNoteBoxPage, handleMoveAttendancePage, unReadCountRef, themeMode, toggleThemeMode)}
                    </Box>

                    <Stack ref={mobileToolbarRef}
                           sx={{
                               // display: state.openMobileMenu ? 'flex' : 'none',
                               display: 'flex',
                               width: '100vw',
                               position: 'absolute',
                               top: 65,
                               left: state.openMobileMenu ? 0 : `calc(-100vw)`,
                               transition: styles.transition,
                               background: '#2a2a2a',
                               height: `calc(100vh - 65px)`,
                               overflow: 'scroll',
                           }}>
                        {
                            config.menu.map((value, index) => {
                                if (value.admin) {
                                    if (!userEmpty && commonData.user.admin != true) {
                                        return;
                                    }
                                }
                                if (!value.usage) {
                                    return;
                                }
                                return (
                                    <Stack key={index}
                                           sx={{
                                               width: 1,
                                               display: 'flex',
                                               justifyContent: 'center',
                                               alignItems: 'flex-start',
                                               mb: 1,
                                           }}>
                                        <Button variant={'text'}
                                                sx={{width: 1, display: 'flex', justifyContent: 'flex-start'}}
                                                onClick={() => movePage(value, value.subMenu[0])}>
                                            <Typography variant={'subtitle1'}
                                                        sx={{
                                                            ml: 1,
                                                            fontWeight: '600',
                                                            pt: 2,
                                                            color: '#e75c5c',
                                                        }}>{value.name}</Typography>
                                        </Button>
                                        {/*<Divider variant={'fullWidth'} sx={{width: 1}}/>*/}
                                        {
                                            value.subMenu.map((subMenu, si) => {
                                                if (!subMenu.usage) {
                                                    return;
                                                }
                                                return (
                                                    <Button key={si}
                                                            variant={'text'}
                                                            sx={{
                                                                width: 1,
                                                                display: 'flex',
                                                                justifyContent: 'flex-start'
                                                            }}
                                                            onClick={() => movePage(value, subMenu)}>
                                                        <Typography variant={'subtitle2'}
                                                                    sx={{
                                                                        ml: 4,
                                                                        fontWeight: '400',
                                                                        // pt: 0.5,
                                                                        color: '#fff'
                                                                    }}>{subMenu.name}</Typography>
                                                    </Button>
                                                );
                                            })
                                        }
                                    </Stack>
                                );
                            })
                        }
                    </Stack>
                </Toolbar>


                {/* PC */}
                <Toolbar ref={toolbarRef} sx={{
                    display: {xs: 'none', sm: 'none', md: 'none', lg: 'flex'},
                    background: 'var(--scc-surface)',
                    alignItems: 'flex-start',
                    transition: config.style.transition,
                }}>
                    <Box onClick={moveMainPage}
                         sx={{display: 'flex', width: 0.1, height: 1}}>
                        <img ref={logoRef}
                             src={defaultLogoSrc}
                             style={{height: '100px', cursor: 'pointer'}}
                             alt={'로고'}/>
                    </Box>

                    {/* 메뉴 */}
                    <Stack ref={menuRef}
                           sx={{
                               width: 0.8,
                               // height: 1,
                               display: 'flex',
                               justifyContent: 'center',
                               alignItems: 'center',
                               color: 'var(--scc-menu-text)',
                           }}>
                        {/* 상위메뉴 */}
                        <Box sx={{
                            width: 1, height: 100, display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}>
                            {
                                config.menu.map((value, index) => {
                                    if (value.admin && !userEmpty && !commonData.user.admin) {
                                        return;
                                    }
                                    if (!value.usage) {
                                        return;
                                    }
                                    return (
                                        <Box key={index}
                                             onMouseOver={() => handleMouseOverMenu()}
                                             onMouseLeave={() => handleMouseLeaveMenu()}
                                             sx={{
                                                 width: menuColumnWidth,
                                                 height: 1,
                                                 display: 'flex',
                                                 justifyContent: 'center',
                                                 alignItems: 'center',
                                                 cursor: 'pointer',
                                                 ':hover': {
                                                     color: 'red',
                                                 },
                                                 transition: config.style.transition,
                                             }}>
                                            <Button variant={'text'}
                                                    onClick={() => movePage(value, value.subMenu[0])}>
                                                <Typography variant={'h6'}
                                                            sx={{
                                                                fontWeight: '600',
                                                                transition: config.style.transition,
                                                                color: value.id === state.selectedMenuId ?
                                                                    '#ff0000' :
                                                                    state.openMenu ? '#d4d4d4' : 'var(--scc-menu-text)',
                                                                ':hover': {
                                                                    borderBottom: '1px solid',
                                                                    color: '#ff0000',
                                                                },
                                                                p: 0,
                                                            }}>{value.name}</Typography>
                                            </Button>
                                        </Box>
                                    );
                                })
                            }
                        </Box>


                        {/* 서브메뉴 */}
                        <Box ref={subMenuRef}
                             onMouseOver={() => handleMouseOverMenu()}
                             onMouseLeave={() => handleMouseLeaveMenu()}
                             sx={{
                                 width: 1,
                                 display: 'flex',
                                 height: 0,
                                 justifyContent: 'center',
                                 overflow: 'hidden',
                                 transition: config.style.transition,
                             }}>
                            {
                                config.menu.map((value, index) => {
                                    if (value.admin && !userEmpty && !commonData.user.admin) return;
                                    if (!value.usage) return;
                                    return (
                                        <Stack key={index}
                                               onMouseOver={() => handleMouseOverMenu()}
                                               onMouseLeave={() => handleMouseLeaveMenu()}
                                               sx={{
                                                   width: menuColumnWidth,
                                                   height: 1,
                                                   display: 'flex',
                                                   justifyContent: 'flex-start',
                                                   alignItems: 'center',
                                                   cursor: 'pointer',
                                               }}>
                                            {
                                                value.subMenu.map((subMenu, i) => {
                                                    if (!subMenu.usage) {
                                                        return;
                                                    }
                                                    return (
                                                        <Button key={i}
                                                                variant={'text'}
                                                                onClick={() => movePage(value, subMenu)}>
                                                            <Typography variant={'subtitle1'}
                                                                        sx={{
                                                                            fontWeight: '600',
                                                                            color: state.openMenu ? '#d4d4d4' : 'var(--scc-menu-text)',
                                                                            ':hover': {
                                                                                color: '#ff0000',
                                                                            },
                                                                            transition: config.style.transition,
                                                                            p: 1,
                                                                            // ...styles.textKeepAll
                                                                        }}>{subMenu.name}</Typography>
                                                        </Button>
                                                    );
                                                })
                                            }
                                        </Stack>
                                    );
                                })
                            }
                        </Box>
                    </Stack>


                    {getSettingBox(handleOpenSettingBox, state, commonData, handleOpenChangePassword, logOut, userEmpty, handleMoveNoteBoxPage, handleMoveAttendancePage, unReadCountRef, themeMode, toggleThemeMode)}
                </Toolbar>
            </AppBar>


            {ChangePasswordDialog(state, setState)}
            {EventConfirmDialog()}
        </>
    );
}


function getSettingBox(
    handleOpenSettingBox: (key: string) => void,
    state: State,
    commonData: any,
    handleOpenChangePassword: () => void,
    logOut: () => void,
    userEmpty: boolean,
    handleMoveNoteBoxPage: (sub: string) => void,
    handleMoveAttendancePage: () => void,
    unReadCountRef: any,
    themeMode: 'light' | 'dark',
    toggleThemeMode: () => void,
) {
    return <>
        {/* 정보 수정, 로그인 or 로그아웃*/}
        <Box sx={{
            position: 'absolute',
            right: 0,
            display: 'flex',
            alignItems: 'center',
            pr: {xs: 1, sm: 1, md: 2},
            width: 0.1,
            height: {xs: 65, sm: 65, md: 100}
        }}>
            <Box sx={{
                display: 'flex',
                width: 1,
                justifyContent: 'flex-end',
                alignItems: 'center',
                position: 'relative'
            }}>
                {/* 쪽지 버튼 */}
                <Box sx={{display: 'flex', position: 'relative'}}>
                    <Box sx={{
                        position: 'absolute',
                        display: 'flex',
                        justifyContent: 'center',
                        borderRadius: 100, background: '#ff2929', width: 17, height: 17,
                        right: 10,
                        top: -3
                    }}>
                        <Typography ref={unReadCountRef} align={"center"} sx={{color: '#fff', fontWeight: 'bold'}}
                                    variant={"caption"}>
                            {'0'}
                        </Typography>
                    </Box>
                    <Tooltip title={'쪽지함'}>
                        <EmailIcon color={"action"}
                                   onClick={() => handleOpenSettingBox('openNoteBox')}
                                   fontSize={'large'}
                                   sx={{cursor: 'pointer', mr: 2}}/>
                    </Tooltip>
                </Box>

                {/* 다크 모드 토글 */}
                <Tooltip title={themeMode === 'dark' ? '라이트 모드' : '다크 모드'}>
                    <Box
                        component="span"
                        onClick={toggleThemeMode}
                        sx={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: 'pointer',
                            mr: 2,
                            width: 38,
                            height: 38,
                            borderRadius: '50%',
                            transition: 'transform 0.35s cubic-bezier(0.34, 1.56, 0.64, 1), background-color 0.2s',
                            color: themeMode === 'dark' ? '#ffd166' : '#5c6bc0',
                            filter: themeMode === 'dark'
                                ? 'drop-shadow(0 0 6px rgba(255, 209, 102, 0.55))'
                                : 'drop-shadow(0 0 4px rgba(92, 107, 192, 0.35))',
                            '@keyframes sccThemePulse': {
                                '0%, 100%': {transform: 'scale(1)'},
                                '50%': {transform: 'scale(1.08)'},
                            },
                            animation: 'sccThemePulse 2.6s ease-in-out infinite',
                            '&:hover': {
                                animation: 'none',
                                transform: 'rotate(25deg) scale(1.15)',
                                backgroundColor: themeMode === 'dark'
                                    ? 'rgba(255, 209, 102, 0.12)'
                                    : 'rgba(92, 107, 192, 0.12)',
                            },
                        }}
                    >
                        {themeMode === 'dark'
                            ? <LightModeIcon fontSize={'large'}/>
                            : <DarkModeIcon fontSize={'large'}/>}
                    </Box>
                </Tooltip>
                <Paper sx={{
                    p: 1,
                    display: 'flex',
                    transition: styles.transition,
                    border: styles.border,
                    position: 'absolute',
                    zIndex: 10,
                    top: 50,
                    right: state.openNoteBox ? 10 : -200,
                    minWidth: 100,
                }}>
                    <Stack sx={{width: 1, display: 'flex', alignItems: 'center'}}>
                        <Button variant={'text'}
                                onClick={() => handleMoveNoteBoxPage('send-note')}>
                            <Typography variant={'subtitle1'} sx={{color: 'var(--scc-menu-text)'}}>
                                {'쪽지보내기'}
                            </Typography>
                        </Button>
                        <Button variant={'text'}
                                onClick={() => handleMoveNoteBoxPage(constance.noteType.inBox)}>
                            <Typography variant={'subtitle1'} sx={{color: 'var(--scc-menu-text)'}}>
                                {'받은쪽지함'}
                            </Typography>
                        </Button>
                        <Button variant={'text'}
                                onClick={() => handleMoveNoteBoxPage(constance.noteType.sentInbox)}>
                            <Typography variant={'subtitle1'} sx={{color: 'var(--scc-menu-text)'}}>
                                {'보낸쪽지함'}
                            </Typography>
                        </Button>
                    </Stack>
                </Paper>


                {/* 설정 버튼 */}
                <Tooltip title={'설정'}>
                    <SettingsIcon color={"action"}
                                  onClick={() => handleOpenSettingBox('openSettingBox')}
                                  fontSize={'large'}
                                  sx={{cursor: 'pointer'}}/>
                </Tooltip>

                <Paper sx={{
                    p: 1,
                    display: 'flex',
                    transition: styles.transition,
                    minHeight: 50,
                    border: styles.border,
                    position: 'absolute',
                    zIndex: 10,
                    top: 50,
                    right: state.openSettingBox ? 0 : -200,
                    width: 150,
                }}>
                    <Stack sx={{width: 1, display: 'flex', alignItems: 'center'}}>
                        <Box sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            borderBottom: styles.border,
                            p: 1,
                            width: 1
                        }}>
                            <Typography variant={'subtitle1'} sx={{color: 'var(--scc-menu-text)'}}>
                                {`${commonData.user.departmentName} ${commonData.user.name}`}
                            </Typography>
                        </Box>

                        <Box sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            borderBottom: styles.border,
                            p: 1,
                            width: 1
                        }}>
                            <Button variant={'text'}
                                    onClick={() => handleMoveAttendancePage()}>
                                <Typography variant={'subtitle1'} sx={{color: 'var(--scc-menu-text)'}}>
                                    {'출석체크'}
                                </Typography>
                            </Button>
                        </Box>


                        <Button variant={'text'}
                                onClick={() => handleOpenChangePassword()}>
                            <Typography variant={'subtitle1'} sx={{color: 'var(--scc-menu-text)'}}>
                                {'비밀번호 변경'}
                            </Typography>
                        </Button>

                        <Button variant={'text'}
                                onClick={logOut}>
                            <Typography variant={'subtitle1'} sx={{color: 'var(--scc-menu-text)'}}>
                                {
                                    userEmpty ? '로그인' : '로그아웃'
                                }
                            </Typography>
                        </Button>
                    </Stack>
                </Paper>
            </Box>
        </Box>
    </>;
}
